export default __webpack_public_path__ + "static/media/search_not_found.e7f0e2c8.svg";